// WeeklyRoiReportCard.jsx — تقرير ليلى الأسبوعي لأثر أكواد الحملات (واتساب)
import React, { useEffect, useState } from "react";
import { api, formatErr } from "./lib/api";
import { useAuth } from "./lib/auth";
import { showToast } from "./lib/theme";

export default function WeeklyRoiReportCard() {
  const { user } = useAuth();
  const [lastSent, setLastSent] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState("");
  const allowed = user && ["admin", "ceo"].includes(user.role);

  useEffect(() => {
    if (!allowed) return;
    api.get("/layla-report/settings")
      .then((r) => setLastSent(r.data?.weekly_last_sent || null))
      .catch(() => {});
  }, [allowed]);

  if (!allowed) return null;

  const doPreview = async () => {
    setBusy("preview");
    try {
      const r = await api.get("/layla-report/preview-weekly");
      setPreview(r.data?.message || "");
    } catch (e) { showToast(formatErr(e), "error"); }
    setBusy("");
  };

  const doSend = async () => {
    setBusy("send");
    try {
      const r = await api.post("/layla-report/send-weekly-now");
      showToast(`✅ أُرسل التقرير الأسبوعي عبر واتساب إلى ${r.data?.sent_to ?? 0} مستلم`, "success");
      const s = await api.get("/layla-report/settings");
      setLastSent(s.data?.weekly_last_sent || null);
    } catch (e) { showToast(formatErr(e), "error"); }
    setBusy("");
  };

  return (
    <div className="card" data-testid="weekly-roi-report-card" style={{ marginBottom: 14, padding: "14px 18px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
        <div>
          <div style={{ fontSize: 14.5, fontWeight: 800, color: "var(--brown-deep)" }}>
            📬 تقرير ليلى الأسبوعي — ROI الأكواد
          </div>
          <div style={{ fontSize: 11.5, color: "var(--muted)", marginTop: 2 }}>
            يُرسل تلقائياً كل أحد 8:00 صباحاً (توقيت السعودية) عبر واتساب للإدارة.
            {lastSent?.week && (
              <span data-testid="weekly-roi-last-sent"> · آخر إرسال: أسبوع {lastSent.week} ({lastSent.sent_to ?? 0} مستلم)</span>
            )}
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn btn-ghost" data-testid="weekly-roi-preview-btn"
            disabled={!!busy} onClick={preview !== null ? () => setPreview(null) : doPreview}>
            {busy === "preview" ? "…" : preview !== null ? "إخفاء المعاينة" : "👁 معاينة"}
          </button>
          <button className="btn btn-primary" data-testid="weekly-roi-send-btn"
            disabled={!!busy} onClick={doSend}>
            {busy === "send" ? "جارٍ الإرسال…" : "📤 إرسال الآن"}
          </button>
        </div>
      </div>
      {preview !== null && (
        <pre data-testid="weekly-roi-preview" dir="rtl" style={{
          marginTop: 12, padding: "12px 14px", background: "#ECE5DD", borderRadius: 10,
          fontSize: 12.5, lineHeight: 1.8, whiteSpace: "pre-wrap", fontFamily: "inherit",
          border: "1px solid var(--border)", color: "#333",
        }}>{preview || "لا توجد بيانات بعد"}</pre>
      )}
    </div>
  );
}
